var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('./identity-chains'),
    getIdentityRootChain = _require.getIdentityRootChain,
    getServerManagementSubchain = _require.getServerManagementSubchain;

var cbAddress = require('./coinbase-address');

var eff = require('./efficiency');

function getIdentity(_x, _x2) {
  return _getIdentity.apply(this, arguments);
}

function _getIdentity() {
  _getIdentity = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(cli, rootChainId) {
    var rootChain, managementSubchain, coinbaseAddress, efficiency;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getIdentityRootChain(cli, rootChainId);

          case 2:
            rootChain = _context.sent;
            _context.next = 5;
            return getServerManagementSubchain(cli, rootChain.serverManagementSubchainId, rootChainId);

          case 5:
            managementSubchain = _context.sent;
            coinbaseAddress = cbAddress.extract(rootChainId, rootChain.entries, rootChain.identityKeys[0]);
            efficiency = eff.extract(rootChainId, managementSubchain.entries, rootChain.identityKeys[0]);
            return _context.abrupt("return", {
              rootChainId: rootChainId,
              serverManagementSubchainId: rootChain.serverManagementSubchainId.toString('hex'),
              coinbaseAddress: coinbaseAddress,
              efficiency: efficiency,
              identityKeys: rootChain.identityKeys.map(function (ik) {
                return ik.toString('hex');
              })
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getIdentity.apply(this, arguments);
}

function getIdentityHistory(_x3, _x4) {
  return _getIdentityHistory.apply(this, arguments);
}

function _getIdentityHistory() {
  _getIdentityHistory = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(cli, rootChainId) {
    var rootChain, managementSubchain, coinbaseAddressHistory, efficiencyHistory;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getIdentityRootChain(cli, rootChainId);

          case 2:
            rootChain = _context2.sent;
            _context2.next = 5;
            return getServerManagementSubchain(cli, rootChain.serverManagementSubchainId, rootChainId);

          case 5:
            managementSubchain = _context2.sent;
            coinbaseAddressHistory = cbAddress.extractHistory(rootChainId, rootChain.entries, rootChain.identityKeys[0]);
            efficiencyHistory = eff.extractHistory(rootChainId, managementSubchain.entries, rootChain.identityKeys[0]);
            return _context2.abrupt("return", {
              rootChainId: rootChainId,
              serverManagementSubchainId: rootChain.serverManagementSubchainId.toString('hex'),
              coinbaseAddressHistory: coinbaseAddressHistory,
              efficiencyHistory: efficiencyHistory,
              identityKeys: rootChain.identityKeys.map(function (ik) {
                return ik.toString('hex');
              })
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getIdentityHistory.apply(this, arguments);
}

module.exports = {
  getIdentity: getIdentity,
  getIdentityHistory: getIdentityHistory
};